import { Component, OnInit, Inject } from '@angular/core';
import { AngularFireAuth, AngularFireAuthModule } from '@angular/fire/auth'
import { AngularFirestore } from '@angular/fire/firestore/';
import { Router, Route, ActivatedRoute, UrlSegment, NavigationEnd } from '@angular/router';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFireStorage } from '@angular/fire/storage/';
import { MatDialog } from '@angular/material/dialog';
import { UserPanelService } from '../user-panel.service';
import { DOCUMENT } from '@angular/common';
import { NewPasswordDialogComponent } from '../new-password-dialog/new-password-dialog.component';
import { SubjectsChooserDialogComponent } from '../subjects-chooser-dialog/subjects-chooser-dialog.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  user: any;
  currentRoute: string;
  constructor(
    private auth: AngularFireAuth,
    private firestore: AngularFirestore,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private storage: AngularFireStorage,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private userPanelService: UserPanelService) {
    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.currentRoute = val.url;
      }
    });
    auth.onAuthStateChanged((userInfo) => {
      this.user = userInfo;
      if (userInfo) {
        this.firestore.doc(`users/${userInfo.uid}`).get()
          .subscribe(async (u) => {
            console.log(u)
            if (!u.data().newYearSubjectsSelected && u.data().group == 'FON')
              this.firestore.collection('subjectsWebsiteFON').get()
                .subscribe(subjectsSnap => {
                  let subjects = subjectsSnap.docs.map(subjectSnap =>{
                    let subject = subjectSnap.data();
                    subject.id = subjectSnap.id;
                    return subject;
                  } )
                  dialog.open(SubjectsChooserDialogComponent, {
                    data: {
                      subjects: subjects
                    },
                    maxHeight: "90vh",
                    height: "90vh",
                    width: "90vw",
                    disableClose: true
                  })
                })
          })
      }
    })
  }

  ngOnInit(): void {
  }

  goToProfile() {
    // this.document.location.href = 'korisnik';
    this.router.navigateByUrl('korisnik')
  }
  goToCalculator() {
    // this.document.location.href = 'kalkulator';
    this.router.navigateByUrl('kalkulator')
  }
  async openRegistrationDialog() {
    var currentUser = await this.auth.currentUser;
    if (true) {
      console.log(window.outerWidth)
      var width = '40%';
      if (window.outerWidth < 992) width = "80%"
      const dialogRef = this.dialog.open(RegisterDialogComponent, {
        width: width,
        height: '90%',
        data: {
        },
        panelClass: 'submitDialogStyle'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 200) this.openSnackBar("Registracija uspešna!", "ok")
        else if (result === 400) this.openSnackBar("Registracija neuspešna. Molimo vas da probate ponovo", "ok")
      });
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  async signOut() {
    await this.auth.signOut()
    this.router.navigateByUrl('kalkulator')
  }

}
